import { apiSlice } from "../../app/api/apiSlice";

// LC-705: copy URLA Part 4 to the CD5 Mortgage Broker section and the
// Broker file contact after the loan fields are written.
export const syncBrokerContactApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		syncBrokerContact: builder.mutation({
			query: ({ loan_guid, loan_number }) => ({
				url: "/api/v1/loan/sync_broker_contact/",
				method: "POST",
				body: { loan_guid, loan_number },
			}),
		}),
	}),
});

export const { useSyncBrokerContactMutation } = syncBrokerContactApiSlice;
